import { compile } from 'path-to-regexp';

import { getActiveLocale } from '@openclassrooms/translations';

import getPath from './getPath';

export default function getPathName(path, args, shouldPrependLang = true) {
  if (!path || !path.startsWith('/')) {
    return '';
  }

  const [basePath] = path.split(/[?#]/);
  const pathToParse = shouldPrependLang ? getPath(basePath) : basePath;

  const stringifiedArgs = args
    ? Object.fromEntries(Object.entries(args).map(([key, value]) => [key, String(value)]))
    : {};

  const argsWithLang = {
    ...stringifiedArgs,
    lang: getActiveLocale(),
  };

  const toPath = compile(pathToParse, { encode: encodeURIComponent });

  return toPath(argsWithLang);
}
